module.exports = __webpack_public_path__ + "static/media/cherry-tree.5a0cd277.jpg";